import UIkit from 'uikit';

function getDataParams(element, attributeName = 'data-vy-ajax') {
  const rawData = $(element).attr(attributeName);
  if (!rawData) return {};

  return rawData.includes('{') ? parseComplexFormat(rawData) : parseSimpleFormat(rawData);
}

function parseSimpleFormat(rawData) {
  return Object.fromEntries(
    rawData.split(';')
      .map(param => param.split(':').map(s => s.trim()))
      .filter(([key, value]) => key && value)
      .map(([key, value]) => [key, convertValue(value)])
  );
}

function parseComplexFormat(rawData) {
  const result = {};
  rawData.replace(/(\w+):\{([^}]*)\}/g, (_, key, value) => {
    result[key] = parseSimpleFormat(value);
  });
  rawData.split(';').forEach(part => {
    if (!part.includes('{') && !part.includes('}')) {
      const [key, value] = part.split(':').map(s => s.trim());
      if (key && value && !(key in result) && !(key in (result.query || {}))) {
        result[key] = convertValue(value);
      }
    }
  });
  return result;
}

function convertValue(value) {
  return value === 'true' ? true : value === 'false' ? false : (!isNaN(value) ? Number(value) : value);
}

function extractPageNumber(url) {
  const pageMatch1 = url.match(/page\/(\d+)/);
  const pageMatch2 = url.match(/paged=(\d+)/);
  return pageMatch1 ? pageMatch1[1] : (pageMatch2 ? pageMatch2[1] : 1);
}

function update_url_params(params = {}, paginationKey = 'paged', pageNumber = 1) {
  const url = new URL(window.location.origin + window.location.pathname);

  url.pathname = url.pathname.replace(/\/page\/\d+/, '');

  if (pageNumber > 1) {
    url.searchParams.set(paginationKey, pageNumber);
  } else {
    url.searchParams.delete(paginationKey);
  }

  Object.entries(params).forEach(([key, value]) => {
    if (value && value !== '') {
      url.searchParams.set(key, value);
    } else {
      url.searchParams.delete(key);
    }
  });

  update_url(url);
}

function update_url(url) {
  window.history.pushState({}, '', url);
}

// FILTER AJAX
function ajax_filter(ajax, pageNumber = 1) {

  if (ajax.length == 0) {
    console.error('Aucun élément [data-vy-ajax] trouvé');
    return;
  }

  const ajaxParams = getDataParams(ajax);
  const urlParams = {};

  var taxonomy = {};
  var metaquery = {};
  var search = false;
  var hasActiveFilter = false;

  if (ajax.find('[data-vy-ajax-search]').length) {
    search = ajax.find('[data-vy-ajax-search]').val();
    if (search) {
      hasActiveFilter = true;
    }
    var paramsSearch = getDataParams(ajax.find('[data-vy-ajax-search]'), 'data-vy-ajax-search');
    if (paramsSearch.addurl) urlParams[paramsSearch.addurl] = search;
  }

  ajax.find('select[data-vy-ajax-taxonomy]').each(function() {
    const select = $(this);
    if (select.val() !== '0') {
      hasActiveFilter = true;
    }
    const paramsTaxo = getDataParams(this, 'data-vy-ajax-taxonomy');

    if (select.val() != '0') {
      const selectedOption = select.find('option:selected');

      // Get the operator (from params, then option data, or empty)
      const operator = paramsTaxo.operator ||
        selectedOption.data('vy-ajax-operator') ||
        '';

      // Get the field (from params, then option data, or empty)
      const field = paramsTaxo.field ||
        selectedOption.data('vy-ajax-field') ||
        '';

      // Get the value (from option data if available, otherwise the option value)
      const value = selectedOption.data('vy-ajax-taxvalue') !== undefined ?
        selectedOption.data('vy-ajax-taxvalue') :
        select.val();

      // Create the taxonomy object
      taxonomy[paramsTaxo.taxonomy] = {
        value: value,
        field: field,
        operator: operator
      };

      if (paramsTaxo.addurl) {
        urlParams[paramsTaxo.addurl] = select.val();
      }
    }
  });
  $('.vy_archive_filters_button .uk-badge').addClass('uk-hidden');
  ajax.find('[data-vy-ajax-taxonomy*="checkboxes"]:has(input[type="checkbox"]:checked)').each(function() {
    const container = $(this);
    const paramsTaxo = getDataParams(container[0], 'data-vy-ajax-taxonomy');
    const checkedCheckboxes = container.find('input[type="checkbox"]:checked');
    const badge = container.parent().find('.vy_archive_filters_button .uk-badge');
    const values = [];

    UIkit.drop(container).hide(false);

    if (checkedCheckboxes.length > 0) {

      const field = paramsTaxo.field || '';
      const operator = paramsTaxo.operator || '';

      badge.text(checkedCheckboxes.length);
      badge.removeClass('uk-hidden');

      checkedCheckboxes.each(function() {
        values.push($(this).val());
      });

      if (values.length > 0) {
        taxonomy[paramsTaxo.taxonomy] = {
          value: values,
          field: field,
          operator: operator
        };
      }
      hasActiveFilter = true;
    } else {
      badge.addClass('uk-hidden');
      hasActiveFilter = false;
    }
  });
  ajax.find('select[data-vy-ajax-metaquery]').each(function() {
    const select = $(this);
    if (select.val() !== '0') {
      hasActiveFilter = true;
    }
    const paramsMetaquery = getDataParams(this, 'data-vy-ajax-metaquery');

    if (select.val() != '0') {
      const selectedOption = select.find('option:selected');

      // Get the compare operator (from params, then option data, or empty)
      const compare = paramsMetaquery.metacompare ||
        selectedOption.data('vy-ajax-metacompare') ||
        '';

      // Get the value (from option data if available, otherwise the option value)
      const value = selectedOption.data('vy-ajax-metavalue') !== undefined ?
        selectedOption.data('vy-ajax-metavalue') :
        select.val();

      // Create the metaquery object
      metaquery[paramsMetaquery.metakey] = {
        value: value,
        compare: compare
      };

      if (paramsMetaquery.addurl) {
        urlParams[paramsMetaquery.addurl] = select.val();
      }
    }
  });

  // Check if any filters are active and toggle the 'uk-active' class on the reset button
  const resetButton = ajax.find('[data-vy-ajax-reset]');
  if (hasActiveFilter) {
    resetButton.removeClass('uk-active');
  } else {
    resetButton.addClass('uk-active');
  }


  $('.vy_ajax_skeleton').addClass('--active');

  var data = {
    action: 'filter',
    afp_nonce: afp_vars.afp_nonce,
    params: ajaxParams,
    taxonomy: taxonomy,
    metaquery: metaquery,
    paged: pageNumber,
    search: search,
  };

  if (ajaxParams.items_class && ajaxParams.items_class != '' && ajaxParams.items_path && ajaxParams.items_path != '') {
    $.post(afp_vars.afp_ajax_url, data, function(response) {


      if (!response || !response.status) {
        console.error('Structure de réponse AJAX invalide ou manquante.');
        $('.vy_ajax_skeleton').removeClass('--active');
        return;
      }

      if (response.total) $('[data-vy-ajax-total]').text(response.total);

      if (response.status === 'success' || response.status === 'empty') {
        if (!ajaxParams.featured && typeof ajax !== 'undefined' && ajax.length) {
          ajax.find('[data-vy-ajax-featured]').remove();
        }
        $(ajaxParams.items_class).empty();
        $(ajaxParams.items_class).append(response.html);

        $('.vy_ajax_skeleton').removeClass('--active');

        if (response.status === 'success') {
          update_url_params(
            urlParams,
            ajaxParams.url_pagination || 'paged',
            pageNumber
          );
        }
      } else if (response.status === 'error') {
        console.error('Erreur AJAX: ' + response.html);
        $('.vy_ajax_skeleton').removeClass('--active');
      } else {
        console.error('Statut de réponse AJAX inconnu: ', response);
        $('.vy_ajax_skeleton').removeClass('--active');
      }
    }).fail(function(xhr, textStatus, errorThrown) {
      console.error('Erreur de la requête AJAX elle-même: ' + textStatus + ', ' + errorThrown);
      $('.vy_ajax_skeleton').removeClass('--active');
    });
  } else {
    console.error('Les paramètres items_path et items_class sont requis dans data-vy-ajax.');
    return;
  }

}

// PAGINATION
if ($('[data-vy-ajax]').length > 0) {
  // PAGINATION
  $(document).on('click', '[data-vy-ajax-pager] a.page-numbers', function(e) {
    e.preventDefault();

    const pager = $(this).closest('[data-vy-ajax-pager]');
    const pagerParams = getDataParams(pager, 'data-vy-ajax-pager');
    const pageNumber = extractPageNumber($(this).attr('href'));

    pager.find('.page-numbers').removeClass('uk-active current');
    $(this).addClass('uk-active');

    if (pagerParams.scroll) {
      UIkit.scroll($(this)).scrollTo($(pagerParams.scroll));
    }

    ajax_filter(pager.closest('[data-vy-ajax]'), pageNumber);
  });
  // FORM
  $('[data-vy-ajax-form]').submit(function(e) {
    e.preventDefault();
    ajax_filter($(this).closest('[data-vy-ajax]'));
  });
  // TAXONOMY
  $('select[data-vy-ajax-taxonomy]').change(function() {
    ajax_filter($(this).closest('[data-vy-ajax]'));
  });
  $('select[data-vy-ajax-metaquery]').change(function() {
    ajax_filter($(this).closest('[data-vy-ajax]'));
  });
  // DROPDOWN
  $('[data-vy-ajax-dropdown] a').click(function(e) {
    e.preventDefault();

    const dropdown = $(this).closest('[data-vy-ajax-dropdown]');

    dropdown.find('a').removeClass('uk-active');
    $(this).addClass('uk-active');


    var name = $(this).data('name');
    var slug = $(this).data('slug');
    var id = $(this).data('id');
    $('#' + id + ' .text').text(name);

    const select = dropdown.siblings('[data-vy-ajax-taxonomy][name="' + id + '"]');
    if (select.length) {
      select.find('option[value="' + slug + '"]').prop('selected', true).trigger('change');
    }

    UIkit.dropdown(dropdown).hide(false);

    var newUrl = $(this).attr('href');
    window.history.pushState({ path: newUrl }, '', newUrl);
  });
  // RESET
  $('[data-vy-ajax-reset]').click(function(e) {
    e.preventDefault();
    const ajaxContainer = $(this).closest('[data-vy-ajax]');
    $(this).addClass('uk-active');

    ajaxContainer.find('[data-vy-ajax-search]').val('');

    ajaxContainer.find('select[data-vy-ajax-taxonomy], select[data-vy-ajax-metaquery]').each(function() {
      $(this).val('0');
    });

    $('[data-vy-ajax-taxonomy*="checkboxes"] input[type="checkbox"]').prop('checked', false);
    $('button[data-vy-ajax-taxonomy]').removeClass('uk-active');

    ajaxContainer.find('[data-vy-ajax-dropdown]').each(function() {
      const dropdown = $(this);
      dropdown.find('a').removeClass('uk-active');
      dropdown.find('a:first').addClass('uk-active');
      const defaultText = dropdown.find('a:first').data('name');
      const id = dropdown.siblings('select').attr('name');
      if (id) {
        $('#' + id + ' .text').text(defaultText);
      }
    });

    ajax_filter(ajaxContainer);
  });
}


// ASYNC VIDEO THUMBNAILS (TTFB Optimization for Vimeo)
$(function() {
  $('[data-async-video]').each(function() {
    var $el = $(this);
    var videoUrl = $el.data('async-video');
    
    if (videoUrl) {
      $.ajax({
        url: '/wp-json/vy/v1/video-thumb?url=' + encodeURIComponent(videoUrl),
        type: 'GET',
        success: function(response) {
          if (response.thumbnail) {
            // Check if element is an img tag or a background div
            if ($el.is('img')) {
              $el.attr('src', response.thumbnail);
            } else {
              $el.css('background-image', 'url(' + response.thumbnail + ')');
              $el.addClass('uk-background-cover');
            }
          }
        }
      });
    }
  });
});

// GLOBAL ALERTS & POPUPS — REST API (CDN-cacheable GET)
(function() {
  var globalsContainer = document.getElementById('vy_dynamic_globals');
  if (!globalsContainer) return;

  var currentPostId = parseInt(globalsContainer.getAttribute('data-post-id'), 10) || 0;

  fetch('/wp-json/vy/v1/dynamic-globals')
    .then(function(response) { return response.json(); })
    .then(function(data) {

      // --- ALERT ---
      if (data.alert && data.alert.active && data.alert.html) {
        var alertCookieId = data.alert.cookieid || '';

        // Page exception check (client-side)
        var alertExcluded = data.alert.exception && data.alert.exception.indexOf(currentPostId) !== -1;
        var alertOnlyOn = data.alert.onlyOn && data.alert.onlyOn.length > 0
          ? data.alert.onlyOn.indexOf(currentPostId) !== -1
          : true;

        if (!alertExcluded && alertOnlyOn) {
          // Check sessionStorage for this specific alert
          var storedAlertData = sessionStorage.getItem('globalAlertSeen');
          var hideThisAlert = false;

          if (storedAlertData && alertCookieId) {
            try {
              var alertItem = JSON.parse(storedAlertData);
              var now = new Date().getTime();
              if (alertItem && alertItem.id === alertCookieId && typeof alertItem.expiry === 'number' && now < alertItem.expiry) {
                hideThisAlert = true;
              } else {
                sessionStorage.removeItem('globalAlertSeen');
              }
            } catch (e) {
              sessionStorage.removeItem('globalAlertSeen');
            }
          }

          if (!hideThisAlert) {
            // Inject alert HTML and show it
            globalsContainer.insertAdjacentHTML('afterbegin', data.alert.html);

            var $globalAlertElement = $('#vy_header_global_alert');
            if ($globalAlertElement.length) {
              $globalAlertElement.removeClass('uk-hidden');

              // Bind close button
              $globalAlertElement.find('.vy_header_global_alert_close').click(function() {
                if (alertCookieId && window.sessionStorage) {
                  var expiryTimestamp = new Date().getTime() + (7 * 24 * 60 * 60 * 1000);
                  sessionStorage.setItem('globalAlertSeen', JSON.stringify({
                    id: alertCookieId,
                    expiry: expiryTimestamp,
                  }));
                }
              });
            }
          }
        }
      }

      // --- POPUP ---
      if (data.popup && data.popup.active && data.popup.html) {
        var popupCookieId = data.popup.cookieid || '';

        // Page exception check (client-side)
        var popupExcluded = data.popup.exception && data.popup.exception.indexOf(currentPostId) !== -1;
        var popupOnlyOn = data.popup.onlyOn && data.popup.onlyOn.length > 0
          ? data.popup.onlyOn.indexOf(currentPostId) !== -1
          : true;

        if (!popupExcluded && popupOnlyOn) {
          // Check sessionStorage for this specific popup
          var storedPopupData = sessionStorage.getItem('globalPopupSeen');
          var hideThisPopup = false;

          if (storedPopupData && popupCookieId) {
            try {
              var popupItem = JSON.parse(storedPopupData);
              var popupNow = new Date().getTime();
              if (popupItem && popupItem.id === popupCookieId && typeof popupItem.expiry === 'number' && popupNow < popupItem.expiry) {
                hideThisPopup = true;
              } else {
                sessionStorage.removeItem('globalPopupSeen');
              }
            } catch (e) {
              sessionStorage.removeItem('globalPopupSeen');
            }
          }

          if (!hideThisPopup) {
            // Inject popup HTML into body and show modal
            $('body').append(data.popup.html);

            var $globalPopupElement = $('#vy_popup');
            if ($globalPopupElement.length) {
              UIkit.modal($globalPopupElement).show();

              // Bind close button
              $globalPopupElement.find('.vy_popup_close').click(function() {
                if (popupCookieId && window.sessionStorage) {
                  var popupExpiryTimestamp = new Date().getTime() + (7 * 24 * 60 * 60 * 1000);
                  sessionStorage.setItem('globalPopupSeen', JSON.stringify({
                    id: popupCookieId,
                    expiry: popupExpiryTimestamp,
                  }));
                }
              });
            }
          }
        }
      }
    })
    .catch(function(error) {
      console.error('Error fetching dynamic globals:', error);
    });
})();
